type Scalar = string | number | boolean | null | undefined

function isNonNullObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null
}

export function unwrapValue(value: unknown): Scalar {
  if (!isNonNullObject(value)) {
    return value as Scalar
  }
  if (!("value" in value)) {
    return undefined
  }
  const inner = value.value
  return isNonNullObject(inner) ? undefined : inner as Scalar
}
